import { useState } from 'react'

export const useLoadingStates = () => {
  const [overviewLoaded, setOverviewLoaded] = useState(false)
  const [dailyLoaded, setDailyLoaded] = useState(false)
  const [weeklyLoaded, setWeeklyLoaded] = useState(false)
  const [durationMetricsLoaded, setDurationMetricsLoaded] = useState(false)
  const [aiUsageLoaded, setAIUsageLoaded] = useState(false)

  const resetDailyLoaded = () => setDailyLoaded(false)
  const resetWeeklyLoaded = () => setWeeklyLoaded(false)
  const resetDurationMetricsLoaded = () => setDurationMetricsLoaded(false)
  const resetAIUsageLoaded = () => setAIUsageLoaded(false)

  return {
    overviewLoaded,
    dailyLoaded,
    weeklyLoaded,
    durationMetricsLoaded,
    aiUsageLoaded,

    setOverviewLoaded,
    setDailyLoaded,
    setWeeklyLoaded,
    setDurationMetricsLoaded,
    setAIUsageLoaded,

    resetDailyLoaded,
    resetWeeklyLoaded,
    resetDurationMetricsLoaded,
    resetAIUsageLoaded,
  }
}
